import { GetWireTransferSetupResponse } from '@/features/means-of-payments/api/useGetWireTransferSetupQuery.ts';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Display a card description suitable for display
 *
 * @param prop               Props
 * @param prop.meanOfPayment corresponding meanOfPayment
 *
 * @returns                  CardDescription component
 */
export const CreditCardDescription = ({
  meanOfPayment,
}: {
  meanOfPayment: GetWireTransferSetupResponse;
}) => {
  const { i18n, t } = useTranslation();

  const expiringMonth = meanOfPayment.cardExpMonth;
  const cardExpMonth =
    expiringMonth.toString().length === 1 ? `0${expiringMonth}` : expiringMonth;

  return (
    <Stack
      direction={'row'}
      sx={{
        gap: 1,
        alignItems: 'center',
        height: '100%',
      }}
    >
      <Typography variant={'body2'}>
        {t('ik.invoice.select.paymentMethod.creditCard')}
      </Typography>
      <Typography variant={'body2'}>
        {meanOfPayment.cardBrand?.toUpperCase() ?? ''}
      </Typography>
      <Typography variant={'body2'}>{meanOfPayment.cardLast4}</Typography>
      <Typography variant={'body2'}>
        {i18n.language === 'fr' ?
          `${cardExpMonth}/${meanOfPayment.cardExpYear}`
        : `${meanOfPayment.cardExpYear}/${cardExpMonth}`}
      </Typography>
    </Stack>
  );
};
